module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/heart_filled_highlight.5c0a6cd86848b50e81fcfe30ace479c8.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/heart_filled_highlight.png
// module id = 1671
// module chunks = 1